import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanDeactivateUnsavedChanges {
  canDeactivate: () => boolean | Observable<boolean>;
}

export const unsavedEvaluationChangesGuard: CanDeactivateFn<CanDeactivateUnsavedChanges> = (component) => {
  if (!component?.canDeactivate) {
    return true;
  }

  return component.canDeactivate();
};
